import './NOSCards.css';
import React from 'react';
import { get, getGlobalDictionaryTerm } from '../../../utils';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink';
import ScrollAnimation from 'react-animate-on-scroll';
import { ReactComponent as IconChevronRightLight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../../resources/icons/IconChevronLeftLight.svg';
import { ReactComponent as IconChevronLeftDetLight } from '../../../resources/icons/chevron-left-24-px.svg';
import { ReactComponent as IconChevronRightDetLight } from '../../../resources/icons/chevron-right-24-px.svg';
import LazyPicture from '../../atoms/LazyPicture';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { convertToAnalyticObject } from '../../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
const Cards = _ref => {
  let {
    item,
    itemsLength,
    eventsAnalytics,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
  const cardImageSrc = get(item, 'image.jss.value.src');
  const cardImageAlt = get(item, 'image.jss.value.alt');
  const hasTitle = get(item, 'title.jss.value');
  const hasTag = get(item, 'tag.jss.value');
  const tag = get(item, 'tag.jss');
  const hasDescription = Boolean(get(item, 'description.jss.value'));
  const ctaLabel = get(item, 'ctaLabel.jss.value');
  const ctaLinkHref = get(item, 'ctaLink.jss.value.href');
  const ctaLinktype = get(item, 'ctaLink.jss.value.linktype');
  const cardTitle = get(item, 'title.jss.value');
  const renderContentInLink = children => {
    if (!ctaLinkHref && !pageEditing) return /*#__PURE__*/React.createElement("div", {
      className: "withoutLink"
    }, children);
    let linkTitle = '';
    if (hasTitle && hasTitle) {
      linkTitle = hasTitle;
    } else {
      linkTitle = cardImageAlt ? cardImageAlt : '';
    }
    if (ctaLabel) {
      linkTitle = `${ctaLabel} | ${linkTitle}`;
    }
    if (item.ctaLink.jss && item.ctaLink.jss.value && item.ctaLink.jss.value.target === '_blank') {
      linkTitle = linkTitle ? `${linkTitle} | ${newWindowLabel}` : newWindowLabel;
    }
    return /*#__PURE__*/React.createElement(Link, {
      "aria-label": linkTitle,
      field: item.ctaLink.jss
    }, children);
  };
  const renderLink = () => {
    if (!ctaLabel || !ctaLinkHref) return null;
    if (pageEditing && ctaLinkHref) {
      return /*#__PURE__*/React.createElement(Link, {
        field: item.ctaLink.jss
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "c--link-more"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      href: ctaLinkHref,
      linktype: ctaLinktype,
      isDetSite: isDetSite,
      colorText: `var(--general-card-image-cards-text-color)`,
      color: `var(--general-card-image-cards-color)`,
      colorActive: `var(--general-card-image-cards-background-active-color)`,
      onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['linkClickAnalytics'], params), [cardTitle, ctaLabel])
    }, ctaLabel && ctaLinkHref ? ctaLabel : null, ctaLabel && ctaLinkHref ? isDetSite ? rtl ? /*#__PURE__*/React.createElement(IconChevronLeftDetLight, null) : /*#__PURE__*/React.createElement(IconChevronRightDetLight, null) : rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null) : null));
  };
  const renderCardsViewTwo = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
      className: `card-box theme-contrast nos-cards-image-wrapper-for-two ${itemsLength === 1 ? 'nos-cards-image-one' : ''}`
    }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
      },
      useEmptyPlaceholder: true,
      hover: true,
      className: "NOSCardsImageForTwoItems"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: `${cardImageSrc}&cw=500&ch=375`
    }), /*#__PURE__*/React.createElement("img", {
      src: `${cardImageSrc}&cw=500&ch=375`,
      alt: cardImageAlt
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "textContainerForTwo"
    }, hasTag && /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "b__title",
      field: tag
    }), hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardTitleForTwoItems",
      field: item.title && item.title.jss,
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
      }
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardDescription",
      field: item.description && item.description.jss
    }) : null, renderLink())));
  };
  const renderCardsViewThree = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
      className: "card-box theme-contrast nos-cards-image-wrapper-for-three"
    }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
      },
      useEmptyPlaceholder: true,
      hover: true,
      className: "NOSCardsImageForThreeAndFourItems"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: `${cardImageSrc}&cw=500&ch=375`
    }), /*#__PURE__*/React.createElement("img", {
      src: `${cardImageSrc}&cw=500&ch=375`,
      alt: cardImageAlt
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "textContainer"
    }, hasTag && /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "b__title",
      field: tag
    }), hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardTitle",
      field: item.title && item.title.jss,
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
      }
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardDescription",
      field: item.description && item.description.jss
    }) : null, renderLink())));
  };
  const renderCardsViewFour = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
      className: "card-box-without-alignment theme-contrast"
    }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), cardTitle);
      },
      useEmptyPlaceholder: true,
      hover: true,
      className: "NOSCardsImageForThreeAndFourItems"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: `${cardImageSrc}&cw=500&ch=375`
    }), /*#__PURE__*/React.createElement("img", {
      src: `${cardImageSrc}&cw=500&ch=375`,
      alt: cardImageAlt
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "textContainer"
    }, hasTag && /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "b__title",
      field: tag
    }), hasTitle ? /*#__PURE__*/React.createElement(Text, {
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle);
      },
      tag: "p",
      className: "h__title body-large cardTitle",
      field: item.title && item.title.jss
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardDescription",
      field: item.description && item.description.jss
    }) : null, renderLink())));
  };
  const generalCardsImageMap = {
    '1': renderCardsViewTwo,
    '2': renderCardsViewTwo,
    '3': renderCardsViewThree,
    '4': renderCardsViewFour
  };
  if (itemsLength <= 4) {
    return generalCardsImageMap[itemsLength]();
  }

  // for Carousel only
  return renderCardsViewFour();
};
const NOSCards = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const title = get(fields, 'data.item.title.jss.value');
  const hasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  const childrenItems = get(fields, 'data.item.children', []);
  const ctaLabel = get(fields, 'data.item.ctaLabel.jss.value');
  const ctaLink = get(fields, 'data.item.ctaLink.jss.value.href');
  const ctaLinktype = get(fields, 'data.item.ctaLink.jss.value.linktype');
  const ctaLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  const ctaRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  const items = childrenItems.length ? childrenItems.filter(item => item.title && item.description) : [];
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderButtonLink = () => /*#__PURE__*/React.createElement("div", {
    className: "btnLink"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: `btn ${isDetSite ? 'btn-primary' : 'btn-secondary'}`,
    isDetSite: isDetSite,
    href: ctaLink,
    title: ctaLabel,
    linktype: ctaLinktype,
    ctaLeftIcon: ctaLeftIcon,
    ctaRightIcon: ctaRightIcon,
    rtl: rtl,
    colorText: `var(--general-card-image-cards-text-color)`,
    color: `var(--general-card-image-cards-color)`,
    colorActive: `var(--general-card-image-cards-background-active-color)`,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [title, ctaLabel])
  }, ctaLabel));
  const renderItems = () => {
    return items.map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      style: {
        flex: 1
      },
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1 + index / 3,
      key: index
    }, /*#__PURE__*/React.createElement(Cards, {
      item: item,
      itemsLength: items.length,
      eventsAnalytics: eventsAnalytics,
      params: params
    })));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isDetSite: isDetSite
  }, items.length < 5 && (hasTitle || hasDescription) ? /*#__PURE__*/React.createElement("div", {
    className: "h__txt"
  }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "p componentDescription",
    field: fields.data.item.description.jss
  }) : null) : null, items.length < 5 ? /*#__PURE__*/React.createElement("div", {
    className: "itemsContainer"
  }, renderItems()) : null, items.length >= 5 ? /*#__PURE__*/React.createElement(CarouselProvider, null, _ref3 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: `${hasTitle || hasDescription ? 'card__head' : 'cardHeadOnlyWithPagination'}`
    }, hasTitle || hasDescription ? /*#__PURE__*/React.createElement("div", {
      className: "h__txt"
    }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title componentTitle",
      field: fields.data.item.title.jss
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "p componentDescription",
      field: fields.data.item.description.jss
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNavAnalytics'], params)), false, false, null, isDetSite), renderNextButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['nextNavAnalytics'], params)), false, false, null, isDetSite)))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1101
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1100,
            min: 901
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      },
      containerClass: 'carouselContainer'
    })), ctaLink && ctaLabel ? /*#__PURE__*/React.createElement("div", {
      className: "paginationAndLinkContainer"
    }, renderButtonLink(), /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params)), [], isDetSite, 'var(--general-card-image-cards-color)'))) : /*#__PURE__*/React.createElement("div", {
      className: "paginationWithoutLinkContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params)), [], isDetSite, 'var(--general-card-image-cards-color)'))));
  }) : null);
};
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl,
    className,
    style,
    isDetSite
  } = _ref4;
  const commonStyles = isDetSite ? "c1116aqt" : "c14w22le";
  const ltrStyles = isDetSite ? "lng2ai6" : "lvsba4l";
  const rtlStyles = isDetSite ? "rqe929p" : "rqwu1f2";
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
export { NOSCards };